import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-wams.component.scss?ngResource";
import { Component, ViewChild } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
export let ViewApplicationLocationWamsComponent = class ViewApplicationLocationWamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    routerParamsService;
    showOnlyPropertyAndZoningLayers = true;
    locationForm;
    mapComponent;
    isMapLoaded = false;
    isAppLoaded = false;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.subscribeToSelectedApplication();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe({
            next: (application) => {
                this.selectedApplication = +this.jobId > 0 && application ? application : null;
                if (this.selectedApplication) {
                    this.setMapData();
                }
            }
        });
    }
    setMapData() {
        const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.shape, 102100);
        const centroid = JsonUtils.fromJSON(centroidGeometryArc);
        const geometries = [];
        this.locationForm.get("centroid").setValue(centroid);
        if (this.selectedApplication.applicationPolygons.length > 0) {
            const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationPolygons[0].shape, 102100);
            const polygon = JsonUtils.fromJSON(polygonGeometryArc);
            this.locationForm.get("polygon").setValue(polygon);
            this.locationForm.get("polygonDto").setValue(this.selectedApplication.applicationPolygons[0]);
            geometries.push(polygon);
        }
        else {
            this.locationForm.get("polygon").setValue(null);
            this.locationForm.get("polygonDto").setValue(null);
        }
        if (this.selectedApplication.applicationLines.length > 0) {
            const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationLines[0].shape, 102100);
            const polyline = JsonUtils.fromJSON(polylineGeometryArc);
            this.locationForm.get("polyline").setValue(polyline);
            this.locationForm.get("polylineDto").setValue(this.selectedApplication.applicationLines[0]);
            geometries.push(polyline);
        }
        else {
            this.locationForm.get("polyline").setValue(null);
            this.locationForm.get("polylineDto").setValue(null);
        }
        this.isAppLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        if (this.isAppLoaded && this.isMapLoaded) {
            const geometries = [];
            if (this.selectedApplication !== undefined && this.selectedApplication !== null) {
                if (this.selectedApplication.applicationLines !== null && this.selectedApplication.applicationLines.length > 0) {
                    geometries.push(this.locationForm.get("polyline").value);
                }
                else if (this.selectedApplication.applicationPolygons !== null && this.selectedApplication.applicationPolygons.length > 0) {
                    geometries.push(this.locationForm.get("polygon").value);
                }
                else {
                    geometries.push(this.locationForm.get("centroid").value);
                }
                if (geometries.length > 0) {
                    this.mapComponent.addGeometriesOnMap(geometries, "Draw Tool Layer", true);
                }
                else {
                    this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
                }
            }
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationWamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationWamsComponent);
